import { render, staticRenderFns } from "./SignInButton.vue?vue&type=template&id=ed8a3cbe"
import script from "./SignInButton.vue?vue&type=script&lang=ts"
export * from "./SignInButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports